export default {
  modalName: {
    id: 'cart_insurance_learn_more_modal_name',
    defaultMessage: 'BackUp protection',
  },
  baseLine: {
    id: 'insurance_modal_backup_baseline',
    defaultMessage: 'For the unexpected, get protected',
  },
  warranty: {
    id: 'insurance_modal_comparison_table_warranty',
    defaultMessage: 'Warranty',
  },
  comparisonTable1: {
    id: 'insurance_modal_comparison_table_benefit1',
    defaultMessage: 'Defects covered ',
  },
  comparisonTable2: {
    id: 'insurance_modal_comparison_table_benefit2',
    defaultMessage: 'Drops, spills, cracks ',
  },
  comparisonTable3: {
    id: 'insurance_modal_comparison_table_benefit3',
    defaultMessage: 'Battery replacement discount',
  },
  comparisonTable4: {
    id: 'insurance_modal_comparison_table_benefit4',
    defaultMessage: 'Refund if we can’t fix it',
  },
  contentTitle: {
    id: 'product_jp_back_up_modal_content_title',
    defaultMessage: 'What is Back up ?',
  },
  contentDescriptionPart1: {
    id: 'product_jp_back_up_modal_content_description_part_1',
    defaultMessage:
      'Back Market’s Backup Service is an all-inclusive repair and recovery service that supports repairs for accidental damage caused by water immersion or drops. For devices that cannot be repaired, we also offer data recovery assistance. ',
  },
  contentDescriptionPart2: {
    id: 'product_jp_back_up_modal_content_description_part_2',
    defaultMessage:
      'Typically, all refurbished products sold on Back Market come with a 1-year warranty and a 30-day money-back guarantee for free. By subscribing to the paid Backup Service option, you can enjoy even greater peace of mind while using your product.',
  },
  cta: {
    id: 'product_jp_back_up_modal_cta',
    defaultMessage: 'Learn More',
  },
}
